import React from "react";
import { getParentLabels } from "./Flow";
import { Input } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import "../css/wizard.css";
import { ReactComponent as TrashCanIcon } from "../assets/TrashCanIcon.svg";

/*
Display componenet for the probability tables.
Existance of this and ConditionalProbabilityTable.js isn't optimal, but it works.
*/

//Gets every combination of parent states
//Returns in the form [{parent1: state1, parent2: state2}, ...]
export function parentCombinations(parentData) {
  let parentStates = parentData.map((parent) => {
    let key = Object.keys(parent)[0];
    let value = Object.values(parent)[0].map((state) => Object.keys(state)[0]);
    return { [key]: value };
  });

  //Generates all possible combinations of parent states
  let parentStateCombinations = parentStates.reduce((acc, parent) => {
    let key = Object.keys(parent)[0];
    let value = Object.values(parent)[0];
    let newAcc = [];
    if (acc.length === 0) {
      value.forEach((state) => {
        newAcc.push({ [key]: state });
      });
    } else {
      acc.forEach((accParent) => {
        value.forEach((state) => {
          newAcc.push({ ...accParent, [key]: state });
        });
      });
    }
    return newAcc;
  }, []);

  return parentStateCombinations;
}

//Given an array, will group them in columns as if they were a table
//I.e. subsets of length numRows
export function generateSets(data, numRows) {
  let rowLength = data.length / numRows;
  let sets = [];
  for (let i = 0; i < rowLength; i++) {
    let set = [];
    for (let j = 0; j < numRows; j++) {
      set.push(data[i + j * rowLength]);
    }
    sets.push(set);
  }

  return sets;
}

function ProbabilityTable({
  data,
  id,
  parentStateCombinations,
  delState,
  editProb,
  editStateName,
}) {
  let parentLabels = getParentLabels(id);
  let states = data.states.map((state) => Object.keys(state)[0]);

  let probs = data.condProbVals; //Current probabilities
  let numRows = states.length;
  let sets = generateSets(probs, numRows);

  //Slightly more idiomatic in reverse.
  sets = sets.reverse();
  parentStateCombinations = parentStateCombinations.reverse();
  console.log(parentStateCombinations);

  // TODO, for all css below, if possible move into css file
  return (
    <div style={{ overflow: data.states.length > 4 ? "auto" : null }}>
      <table class="cond-prob-entry">
        <thead class="cond-prob-entry-th">
          {parentStateCombinations.length > 0 && (
            <>
              <tr>
                <th
                  colSpan={parentLabels.length + 1}
                  style={{ border: "0px" }}
                ></th>
                <th
                  colSpan={states.length}
                  style={{
                    borderBottom: "0px",
                    borderTopLeftRadius: "4px",
                    borderTopRightRadius: "4px",
                  }}
                >
                  {data.label}
                </th>
              </tr>
              <tr>
                <th colSpan={parentLabels.length}>Scenarios</th>
                <th style={{ border: "0px" }}></th>
                <th
                  colSpan={states.length}
                  style={{
                    borderTop: "0px",
                    borderBottom: "0px",
                    borderRadius: "0px",
                  }}
                >
                  State Likelihood
                </th>
              </tr>
            </>
          )}
          <tr>
            {parentLabels.map((header, index) => {
              return (
                <th key={index} style={{ borderRadius: "0px" }}>
                  {header}
                </th>
              );
            })}
            {parentStateCombinations.length > 0 && (
              <th style={{ border: "0px" }}></th>
            )}
            {states.map((header, index) => {
              let id = "prob-header-" + index;
              return (
                <th
                  key={index}
                  style={{
                    whiteSpace: "nowrap",
                    borderTopLeftRadius:
                      parentStateCombinations.length === 0 && index === 0
                        ? "4px"
                        : "0px",
                    borderTopRightRadius:
                      parentStateCombinations.length === 0 &&
                      index === states.length - 1
                        ? "4px"
                        : "0px",
                  }}
                >
                  <Input
                    style={{
                      width: `${header.length + 3}ch`,
                      maxWidth: "15ch",
                      padding: "2px 6px",
                    }}
                    id={id}
                    class="state-name-input"
                    type="text"
                    value={header}
                    onChange={(e) => editStateName(index, e)}
                  />
                  {data.states.length > 2 && (
                    <button
                      style={{
                        borderRadius: "50%",
                        backgroundColor: "transparent",
                        border: "none",
                      }}
                      onClick={() => delState(index)}
                    >
                      <TrashCanIcon
                        style={{ width: "1.3em", height: "1.3em" }}
                      />
                    </button>
                  )}
                </th>
              );
            })}
          </tr>
        </thead>
        <tbody>
          {sets.map((set, i) => {
            return (
              <tr key={i}>
                {parentStateCombinations[i] &&
                  Object.values(parentStateCombinations[i]).map(
                    (state, index) => {
                      return <td key={i}>{state}</td>;
                    }
                  )}
                {parentStateCombinations.length > 0 && (
                  <td style={{ border: "0px" }}>
                    <ArrowRightOutlined />
                  </td>
                )}
                {set.map((prob, j) => {
                  let id = "prob-input-" + i + "-" + j;
                  return (
                    <td key={j}>
                      <Input
                        style={{
                          width: `${prob.toString().length + 4}ch`,
                          minWidth: "7ch",
                          maxWidth: "15ch",
                        }}
                        id={id}
                        class="prob-input"
                        type="text"
                        value={prob}
                        onChange={(e) => editProb(i, j, e)}
                      />
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export default ProbabilityTable;
